import { Actions } from './reports.actions';
import { fromJS } from 'immutable';
import * as ReportsTypes from './reports.types'

export const initialState = fromJS(
    {
        createReport: {
            isLoading: false,
        }
    }
)

export function reportsReducer(state = initialState, action: Actions) {

    switch (action.type) {

        case ReportsTypes.CREATE_REPORT_REQUEST: {
            return state
                .setIn(['createReport', 'isLoading'], true)
        }

        case ReportsTypes.CREATE_REPORT_SUCCESS: {
            return state
                .setIn(['createReport', 'isLoading'], false)
        }


        case ReportsTypes.CREATE_REPORT_FAILURE: {
            return state
                .setIn(['createReport', 'isLoading'], false)
        }

        case ReportsTypes.UPDATE_FIELD:
            let fields = [];

            if (action.path === '') {
                fields = action.field.split('.');
            } else {
                fields = action.path
                    .split('.')
                    .concat(action.field.split('.'));
            }
            const value = action.value;

            if (fields.length === 1) {
                return state.set(fields[0], fromJS(value));
            }
            
            return state.setIn(fields, fromJS(value));

        case ReportsTypes.SET_DEFAULT_DATA:
            const path = action.path || '';
            return state.setIn(
                path.split('.'),
                initialState.getIn(path.split('.'))
            );

        default: return state;
    }
}